<ion-card
    class="m-0 rounded-b-md bg-[#F0F0F0] shadow-none dark:border dark:border-solid dark:border-contrast-yellow dark:bg-contrast-black">
    <ion-card-content class="px-4 pb-0 pt-4" [ngClass]="{ 'pb-4': !packageVersion }">
        <div class="mb-4 rounded-lg border-none bg-white px-4 py-[0.625rem] text-base leading-5 shadow-none">
            <ion-label class="m-0 border-none text-grey-dark dark:text-contrast-yellow" *ngIf="packageVersion">
                {{ 'LAST_CHANGES' | translate }} -
                {{ dateTime }}
            </ion-label>
            <ion-label class="m-0 border-none text-grey-dark dark:text-contrast-yellow" *ngIf="!packageVersion">
                {{ 'NO_CHANGES' | translate }}
            </ion-label>
        </div>
        <ul
            class="icon-grid mb-0 grid"
            *ngIf="hasAlerts; else noAlerts"
            [class.single-item]="filteredMessagesSummary.length === 1">
            <li
                class="icon-item before:bg-[#e4e5e7] after:bg-[#e4e5e7] dark:before:bg-contrast-yellow dark:after:bg-contrast-yellow"
                *ngFor="let item of filteredMessagesSummary">
                <span class="flex flex-col items-center py-5 text-center">
                    <ion-icon
                        class="mb-2 text-[1.5rem] text-grey-zambezy dark:text-contrast-yellow"
                        *ngIf="customIconTag(item.tag)"
                        [src]="(assetsPath$ | async) + item?.path"
                        aria-hidden="true">
                    </ion-icon>

                    <ion-icon
                        class="mb-2 text-[1.5rem]"
                        *ngIf="!customIconTag(item.tag)"
                        [name]="item.icon"
                        aria-hidden="true"></ion-icon>

                    <span class="text-base font-medium text-red-600 dark:text-contrast-yellow">
                        {{ item.amount | number: '1.0-0' }} {{ item.tag | translate }}
                    </span>
                </span>
            </li>
        </ul>

        <ng-template #noAlerts>
            <div class="mt-4 py-5 text-center">
                <p class="text-base leading-[22px] text-grey-dark dark:text-contrast-yellow">
                    {{ 'NO_ALERTS' | translate }}
                </p>
            </div>
        </ng-template>
    </ion-card-content>
</ion-card>
